import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import MuiMenuItem from '@mui/material/MenuItem';
import MuiDivider from '@mui/material/Divider';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { useOverflow } from '../OverflowProvider.js';
import { useChecklist } from '../hooks/useChecklist.js';
import { useCascading } from './CascadingProvider.js';
import Hint from '../../Hint/Hint.js';

const Label = styled(MuiTypography) `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
`;
const _MuiMenuItem = styled(MuiMenuItem, {
    shouldForwardProp: prop => prop !== 'fullWidth',
}) `
  ${({ fullWidth }) => fullWidth &&
    `
    width: auto;
    height: auto;
  `};
  cursor: pointer;
`;
const MenuItem = (_a) => {
    var _b;
    var { children, onClick, hint, hintDuration, leftIcon, rightIcon, divider, preventMenuClose, disabled, description, forceLeftIcon } = _a, rest = __rest(_a, ["children", "onClick", "hint", "hintDuration", "leftIcon", "rightIcon", "divider", "preventMenuClose", "disabled", "description", "forceLeftIcon"]);
    const { dense, rootPopupState } = useOverflow();
    const isCheckItem = useChecklist();
    const { parentPopupState } = useCascading();
    const onItemClick = useCallback(event => {
        var _a, _b;
        if (disabled) {
            return;
        }
        if (!preventMenuClose) {
            (_a = parentPopupState === null || parentPopupState === void 0 ? void 0 : parentPopupState.close) === null || _a === void 0 ? void 0 : _a.call(parentPopupState);
            (_b = rootPopupState === null || rootPopupState === void 0 ? void 0 : rootPopupState.close) === null || _b === void 0 ? void 0 : _b.call(rootPopupState);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [onClick, rootPopupState, parentPopupState, preventMenuClose, disabled]);
    const itemIcon = useMemo(() => {
        if (!dense || isCheckItem || forceLeftIcon) {
            return leftIcon;
        }
    }, [dense, isCheckItem, leftIcon, forceLeftIcon]);
    return (jsxs(Fragment, { children: [jsxs(_MuiMenuItem, Object.assign({ onClick: onItemClick, dense: dense, disabled: disabled, onMouseEnter: (_b = parentPopupState === null || parentPopupState === void 0 ? void 0 : parentPopupState._childPopupState) === null || _b === void 0 ? void 0 : _b.close }, rest, { children: [itemIcon, jsx(Hint, Object.assign({ title: hint, duration: hintDuration }, { children: jsx(Label, Object.assign({ as: "div", variant: dense ? 'body1' : 'subtitle2' }, { children: description ? (jsxs(Fragment, { children: [jsx("div", { children: children }), jsx("div", { children: jsx("small", Object.assign({ style: { textTransform: 'none', whiteSpace: 'normal' } }, { children: jsx(Typography, Object.assign({ variant: "body1" }, { children: description })) })) })] })) : (children) })) })), rightIcon] })), divider && !isCheckItem && jsx(MuiDivider, {})] }));
};

export { Label, MenuItem as default };
//# sourceMappingURL=MenuItem.js.map
